import schemaJSON from '@varo/graphql-schema-types/schema.json';
import subscriptionSchemaJSON from '@varo/graphql-schema-types/subscription/subscription-schema.json';

const SCHEMA_KEY = '__schema';
const SCHEMA_TYPES_KEY = 'types';
const SCHEMA_DIRECTIVES_KEY = 'directives';

type Entity = {
  name: string;
  [key: string]: unknown;
};

type Schema = {
  __schema: {
    queryType: Entity | null;
    mutationType: Entity | null;
    subscriptionType: Entity | null;
    types: Entity[];
    directives: Entity[];
  };
};

const hashByName = (entities: Entity[]) => {
  return entities.reduce((acc, entity) => {
    acc[entity.name] = true;

    return acc;
  }, {});
};

const combineLeft = ([root, ...schemas]: Schema[]) => {
  root[SCHEMA_KEY].queryType = {
    name: 'Query',
  };

  root[SCHEMA_KEY].mutationType = {
    name: 'Mutation',
  };

  root[SCHEMA_KEY].subscriptionType = {
    name: 'Subscription',
  };

  const types = root[SCHEMA_KEY][SCHEMA_TYPES_KEY];
  const directives = root[SCHEMA_KEY][SCHEMA_DIRECTIVES_KEY];

  const typesByName = hashByName(types);
  const directivesByName = hashByName(directives);

  schemas.forEach((schema) => {
    schema[SCHEMA_KEY][SCHEMA_TYPES_KEY].forEach((type) => {
      if (!typesByName[type.name]) {
        types.push(type);
      }
    });

    schema[SCHEMA_KEY][SCHEMA_DIRECTIVES_KEY].forEach((type) => {
      if (!directivesByName[type.name]) {
        directives.push(type);
      }
    });
  });

  return root;
};

export const getSchema = () => {
  const schemas = [schemaJSON, subscriptionSchemaJSON];
  const schema = combineLeft(schemas);

  return JSON.stringify(schema, null, 2);
};
